import { useState, useEffect } from "react";
import DownArrow from "../../utils/assets/down-arrow.svg";
import { fetchDeviceByCategory } from "../../actions/admin/leads";
const DeviceSelection = ({name, id, onValueChange}) => {
  const [listData, setListData] = useState([])
  const [isBarOpen, setIsBarOpen] = useState(false);
  const [searchData, setSearchData] = useState([...listData])
  const [inputValue, setInputValue] = useState("")
  const [value, setValue] = useState(name)

    useEffect(() => {
        fetchDeviceByCategory(id).then((res) => {
            setListData(res.data)
            setSearchData(res.data)
            console.log(res.data);
        })
    },[])
    const handleSubmit = (name, item) => {
        setValue(name);
        setIsBarOpen(false);
        onValueChange(item)
        return name
    }
    console.log("value", value);
    const handleSearch = (event) => {
            const value = event.target.value.toLowerCase(); // Get input value
            setInputValue(value); // Update input state
    
        // Filter the data based on the input value
        const filteredData = listData.filter(
            (item) => item.title && item.title.toLowerCase().includes(value)
          );
          setSearchData(filteredData); // Update the filtered data
        
      };
      console.log("searchData", searchData);
  return (
    <div>
      
        <div className="card">
          <div
            className=" p-2 d-flex justify-content-between align-items-center"
            style={{ maxWidth: "150px" }}
            onClick={() => setIsBarOpen(!isBarOpen)}
          >
            <span className="noOverflow">{value}</span>
            <img src={DownArrow} width={15} alt="arrow" />
          </div>
        </div>
        {
          isBarOpen && (
<div className="card position-absolute">
            {/* <div
                className=" p-2 d-flex justify-content-between align-items-center"
                style={{ maxWidth: "150px" }}
                onClick={() => setIsBarOpen(false)}
              >
                <span className="noOverflow">{value}</span>
                <img src={DownArrow} width={15} alt="arrow" />
            </div> */}
            <div className="selectionContainer">
              <div className="m-1 d-flex justify-content-center align-items-center inputSearchBox">
                  <input value={inputValue} placeholder="Type to search" className="form-control" onChange={handleSearch} type="text" />
              </div>
              <div className="d-flex flex-column" style={{padding: '8px'}}>
                  {
                      searchData.length > 0 && searchData.map((item) => {
                          return (
                              <span onClick={() => handleSubmit(item.title, item)} className={`px-2 py-1 hover_effect ${item.title === name || item.name === name ? 'itemSelected' : ''}`} key={item.id}>{item.title}</span>
                          )
                      })
                  }
              </div>
            </div>
        </div>
          )
        }
        
    </div>
  );
};

export default DeviceSelection;
